// @flow
import authLogin from '../auth/login'

/**
 * Login an user using its username and password
 * @param {Object} data User information
 * @param {string} data.username User username
 * @param {string} data.password User password
 * @return {Promise|Error} A resolved Promise with the server response or Rejected with an Error
 */
export const login = (data: {
  email: string,
  password: string,
}): Promise<any> => authLogin(data)

export default login
